import { Audience } from './types';

export const AUDIENCES_MOCK: Audience[] = [
  {
    id: '8a1c0b66-9d2b-4e1f-b0aa-3f7c9e1d4a51',
    externalId: 'a-clientifidelizzati',
    name: 'Clienti Fidelizzati',
    usersCount: 12450,
    status: 'live',
    activeDestinationsCount: 5,
  },
  {
    id: 'b2dd6e9f-7a16-4c4f-8d2c-66a8a93e9c2d',
    externalId: 'a-lookalikebestbuyers',
    name: 'Lookalike Best Buyers',
    usersCount: 38220,
    status: 'live',
    activeDestinationsCount: 3,
  },
  {
    id: 'c4441fb1-5832-4f9b-b88f-1c2b1d3d40ee',
    externalId: 'a-carrelloabbandonato',
    name: 'Carrello abbandonato 7gg',
    usersCount: 4180,
    status: 'live',
    activeDestinationsCount: 2,
  },
  {
    id: 'd8a3a51c-9b4e-4d22-a86b-5c8c5b04ab90',
    externalId: 'a-inattivi90gg',
    name: 'Inattivi 90 giorni',
    usersCount: 21030,
    status: 'warn',
    activeDestinationsCount: 1,
  },
  {
    id: 'e5b8c9a0-3f47-4b1d-9c2a-7b5e8d4c2a13',
    externalId: 'a-leadwebinarq1',
    name: 'Lead webinar Q1',
    usersCount: 1890,
    status: 'live',
    activeDestinationsCount: 1,
  },
  {
    id: 'f6c9d0b1-2e36-4a0c-8b1f-9d4c7e3b1c02',
    externalId: 'a-visitatoripricing',
    name: 'Visitatori pricing page',
    usersCount: 7620,
    status: 'warn',
    activeDestinationsCount: 0,
  },
];

export const DEFAULT_AUDIENCE_ID = AUDIENCES_MOCK[0]!.id;
